// src/styles/theme.js
import { createLightTheme } from "@fluentui/react-components";

// Outlook blue brand ramp (Fluent UI expects shades 10-160, dark to light)
const brandPalette = {
  10: "#001c3d",
  20: "#002a52",
  30: "#003b6c",
  40: "#004983",
  50: "#00568f",
  60: "#00639c",
  70: "#0070ac",
  80: "#0078d4",
  90: "#1a86d9",
  100: "#3593de",
  110: "#50a1e3",
  120: "#6cafe8",
  130: "#88bded",
  140: "#a3cbf1",
  150: "#bfd9f6",
  160: "#dbe7fa",
};

export const lexTheme = {
  ...createLightTheme(brandPalette),
  colorBrandBackground: "#0078d4",
  colorBrandBackgroundHover: "#106ebe",
  colorBrandForeground1: "#0078d4",
  colorNeutralBackground1: "#ffffff",
  colorNeutralBackground2: "#f3f2f1",
  colorNeutralBackground3: "#eff6fc",
  colorNeutralBackground4: "#deecf9",
  colorNeutralForeground1: "#201f1e",
  colorNeutralForeground2: "#3b3a39",
  colorNeutralForeground3: "#605e5c",
  colorNeutralStroke1: "#e1dfdd",
  colorNeutralStroke2: "#edebe9",
};
